import { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CustomTextField from "../../textField/CustomTextField";
import { faSearch, faSyncAlt, faTimes } from '@fortawesome/free-solid-svg-icons';
import "./AssetFilter.css";

const AssetFilter = ({ onSearch, onReset }) => {
    const [status, setStatus] = useState("ShowAll");

    const [serialNumber, setSerialNumber] = useState("");
    const [model, setModel] = useState("");
    const [swVersion, setSwVersion] = useState("");
    const [location, setLocation] = useState("");

    const buildSearchData = (selectedStatus = status) => {
        const filters = {
            model: model.trim(),
            serial: serialNumber.trim(),
            location: location.trim(),
            software_version: swVersion.trim(),
        };

        const searchData = {};

        Object.keys(filters).forEach((key) => {
            if (filters[key]) {
                searchData[key] = filters[key];
            }
        });

        if (selectedStatus === "Online") {
            searchData.connection_status = "connected";
        } else if (selectedStatus === "Offline") {
            searchData.connection_status = "disconnected";
        } else if (selectedStatus === "Muted") {
            searchData.connection_status = "muted";
        }

        return searchData;
    };

    const handleSearch = () => {
        onSearch?.(buildSearchData());
    };

    const handleFilterByStatus = (selectedStatus) => {
        setStatus(selectedStatus);
        onSearch?.(buildSearchData(selectedStatus));
    };

    const handleReset = () => {
        setSerialNumber("");
        setModel("");
        setSwVersion("");
        setLocation("");
        setStatus("ShowAll");
        onReset?.({});
    };

    return (
        <div className="asset-filter-container">
            <div className="asset-filter-wrapper">
                <div className="filter-input-row">
                    <CustomTextField
                        label={"Serial Number"}
                        value={serialNumber}
                        onChange={(e) => setSerialNumber(e.target.value)}
                    />
                    <CustomTextField
                        label={"Model"}
                        value={model}
                        onChange={(e) => setModel(e.target.value)}
                    />
                    <CustomTextField
                        label={"SW Version"}
                        value={swVersion}
                        onChange={(e) => setSwVersion(e.target.value)}
                    />
                    <CustomTextField
                        label={"Location"}
                        value={location}
                        onChange={(e) => setLocation(e.target.value)}
                    />
                </div>
                <div className="filter-button-row">
                    <div className="btn-group">
                        {["ShowAll", "Online", "Offline", "Muted"].map((s) => (
                            <button
                                key={s}
                                type="button"
                                className={`btn ${status === s ? "btn-primary" : "btn-outline"} btn-action`}
                                onClick={() => handleFilterByStatus(s)}

                            >
                                {s}
                            </button>
                        ))}
                    </div>
                    <div className="action-buttons">
                        <button className="btn btn-primary btn-action" onClick={handleSearch}>
                            <FontAwesomeIcon icon={faSearch} className="me-1" />
                            Search
                        </button>
                        <button className="btn btn-primary btn-action" onClick={handleReset}>
                            <FontAwesomeIcon icon={faSyncAlt} className="me-1" />
                            Reset
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AssetFilter;
